export const FETCH_CLIENT_DATA_REQUEST = "FETCH_CLIENT_DATA_REQUEST";
export const FETCH_CLIENT_DATA_SUCCESS = "FETCH_CLIENT_DATA_SUCCESS";
export const FETCH_CLIENT_DATA_FAILURE = "FETCH_CLIENT_DATA_FAILURE";
